import { LocationType } from '~/client/graph'
import { IMapConfiguration } from '~/client/src/shared/components/SitemapsGallery/MapViewsGallery'
import LocationBase from '~/client/src/shared/models/LocationObjects/LocationBase'

export interface ITaggedMap {
  id: string
  name: string
  open: () => void
}

// A Location's own maps: its exact tags, never an ancestor's, among the maps this page shows.
export function taggedMaps(
  location: LocationBase,
  mapIds: readonly IMapConfiguration[],
  currentMapId: string,
): IMapConfiguration[] {
  if (location.is(LocationType.ProjectLocation)) return []
  return mapIds.filter(({ globeViewId, sitemapId }) =>
    globeViewId
      ? globeViewId !== currentMapId && location.isGlobeAssigned(globeViewId)
      : sitemapId !== currentMapId && location.isSitemapAssigned(sitemapId),
  )
}
